// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"28b9999a","592":"72088496","856":"cc8c57ba","952":"2db8a497"}[chunkId] + ".chunk.js";
};